import { tzOffset } from '../../helpers/date-time';
import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import { InfiniteScrollRequest, SortRequest } from '../../types/props';
import { PaymentMethod } from './branches-api';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type TaskTypeType = 'ORDER' | 'ACTION' | 'COMMON';
export type TaskStatusType =
  | 'PROCESS'
  | 'RESERVED'
  | 'PROGRESS'
  | 'SENT_TO_KITCHEN'
  | 'READY_FOR_PICKUP'
  | 'CANCELLED_BY_KITCHEN'
  | 'DELIVERED'
  | 'DONE'
  | 'DONE_BY_ANOTHER_STAFF'
  | 'REJECTED_BY_EXECUTOR'
  | 'REJECTED_BY_ANOTHER_STAFF'
  | 'FAKE'
  | 'AUTO_ARCHIVE'
  | 'RESERVED_BY_ANOTHER_STAFF'
  | 'EMPLOYEE_REQUIRES';

export type TaskCallbackType = {
  name: string;
  phone: string;
  has_whatsapp: boolean;
};

export type TaskType = {
  additional_info: {
    dishes: {
      name: LangType;
      count: number;
      cost: number;
    }[];
  };
  comment: string;
  client_comment: string;
  created_at: string;
  created_by: string;
  deadline: string;
  id: number;
  is_photo_required: boolean;
  photo: string;
  place_name: LangType;
  place_id: number;
  qr?: {
    id: string;
    value: LangType;
  };
  received_by: {
    id: number;
    name: LangType;
  };
  resolved_at: string;
  resolved_by: {
    id: number;
    name: LangType;
  };
  status: TaskStatusType;
  subtitle: string;
  title: LangType;
  type: TaskTypeType;
  payment_method: PaymentMethod;
  status_history: {
    comment: null;
    created_at: string;
    status: TaskStatusType;
    user_id: number;
  }[];
  callback?: TaskCallbackType;
  form_data?: string;
};

const baseUrl = `${managerApiUrl}/task`;

export interface FetchTaskListRequest
  extends PaginationRequest,
    SortRequest,
    InfiniteScrollRequest {
  place_ids?: string;
  id?: string;
  qr_code?: string;
  status?: string;
  name?: string;
  employee?: string;
  comment?: string;
  client_comment?: string;
  created_at?: string;
  done_at?: string;
  type?: TaskTypeType;

  created_at_from?: string;
  created_at_to?: string;
  done_at_from?: string;
  done_at_to?: string;
}

export const fetchTaskList = async (
  params: FetchTaskListRequest,
): Promise<
  PaginationType & { tasks: TaskType[]; done: TaskType[]; fake: TaskType[]; new: TaskType[] }
> => {
  const response = await baseFetch(baseUrl + buildParams({ ...params, offset: -tzOffset }));
  return response;
};

export type PostTaskRequest = {
  text?: string;
  staff_ids: number[];
  staff_id?: number;
  place_id?: number;
};

export const postTask = async (params: PostTaskRequest): Promise<{ data: TaskType[] }> => {
  const response = await baseFetch(baseUrl, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

export const updateTaskExecutor = async (task_id: number, params: { executor_id: number }) => {
  const response = await baseFetch(baseUrl + `/${task_id}/executor`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};
